import React from 'react';
import RoleplaySelectAssign from './RoleplaySelectAssign';
import RoleplayDeadline from './RoleplayDeadline';
import RoleplayScenarios from './RoleplayScenarios';
import Organization from 'infrastructure/Organization';
import RoleplaySelectAssignRep from './RoleplaySelectAssignRep';
import RoleplayBodyDetails from '../AssignRealPlay/RoleplayBodyDetails';

const RoleplayModalBodyDetails = ({
  isLoadingAttitudes,
  isLoadingCoach,
  isInteractive,
  managerOption,
}) => {
  const isRep = Organization.isRep();

  return isInteractive ? (
    <RoleplayBodyDetails isLoadingAttitudes={isLoadingAttitudes} isLoadingCoach={isLoadingCoach} />
  ) : (
    <div style={{ display: 'flex', gap: '0.5rem', flexDirection: 'column' }}>
      {isRep && managerOption && !isInteractive ? null : (
        <p className="heading5" style={{ marginBottom: '0.5rem' }}>
          Roleplay details
        </p>
      )}
      <RoleplayScenarios />
      {!isRep ? (
        <RoleplaySelectAssign />
      ) : (
        <RoleplaySelectAssignRep managerOption={managerOption} />
      )}
      <RoleplayDeadline />
    </div>
  );
};

export default RoleplayModalBodyDetails;
